module.exports = __webpack_public_path__ + "static/media/happy-logo-white.92684dde.svg";